/** Display optional vehicle fields (battery, towing) when empty */
export function formatOptionalField(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  return value;
}
